import {
  MenuItem,
  MuiThemeProvider,
  Select,
} from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import Calender from '../../../components/Calender';
import { ResultCalls } from '../constants';
import { materialTheme, useStyles } from './index.styles';

/**
 * @type {React.FC<import("../../../typings").TFilterSectionProps>}
 * @returns
 */
const FilterSection = ({
  pageState,
  setPageState,
}) => {
  const classes = useStyles();
  const {
    currentDate,
    selectedGroupCallValue,
    selectedResultCallValue,
    allGroupCalls,
  } = pageState;
  const { isMobile } = useSelector((state) => state.appReducer);

  const ChangeGroup = async (value) => {
    setPageState((prev) => ({
      ...prev,
      selectedGroupCallValue: value,
    }));
  };

  const ChangeLimit = (value) => {
    setPageState((prev) => ({
      ...prev,
      selectedResultCallValue: value,
    }));
  };


  const getDateHandler = (e, event) => {
    localStorage.setItem('Date', e);
    setPageState((prev) => ({
      ...prev,
      currentDate: e,
    }));
  }

  return (
    <div
      className={isMobile ? classes.firstDivMobile : classes.firstDiv}
    >
      <div>
        <div className={classes.textDiv}>Calendar</div>
        <Calender
          value={currentDate}
          disabled={false}
          getDate={(e, event) => getDateHandler(e, event)}
        />
      </div>
      <div>
        <div className={classes.textDiv}>Group</div>
        <div
          className={isMobile ? classes.selectMobile : classes.select}
        >
          <MuiThemeProvider theme={materialTheme}>
            <Select
              style={{ borderBottom: 'none' }}
              labelId='demo-simple-select-label'
              inputProps={{ className: classes.selectBox }}
              value={`${selectedGroupCallValue ? selectedGroupCallValue : ''
                }`}
              name='Group'
              type='Group'
              onChange={(event) => {
                ChangeGroup(event.target.value);
              }}
            >
              {allGroupCalls &&
                allGroupCalls.map((oneGroup, i) => {
                  return (
                    <MenuItem key={i} value={oneGroup.value}>
                      {oneGroup.label}
                    </MenuItem>
                  );
                })}
            </Select>
          </MuiThemeProvider>
        </div>
      </div>
      <div>
        <div className={classes.textDiv}>Results</div>
        <div
          className={isMobile ? classes.selectMobile : classes.select}
        >
          <MuiThemeProvider theme={materialTheme}>
            <Select
              style={{ borderBottom: 'none' }}
              labelId='demo-simple-select-label'
              inputProps={{ className: classes.selectBox }}
              value={selectedResultCallValue}
              name='Group'
              type='Group'
              onChange={(event) => ChangeLimit(event.target.value)}
            >
              {ResultCalls &&
                ResultCalls.map((oneResult, i) => {
                  return (
                    <MenuItem key={i} value={oneResult.value}>
                      {oneResult.label}
                    </MenuItem>
                  );
                })}
            </Select>
          </MuiThemeProvider>
        </div>
      </div>
    </div>
  );
};

export default FilterSection;



// WEBPACK FOOTER //
// ./src/Pages/HomePage/FilterSection/index.jsx